import { TextsetContextProvider } from '@/contexts/TextSetContext/entry';
import { SetsSelectedWrapper } from './SetsSelectedWrapper';
import { StackScreenProps } from '@react-navigation/stack';
import { TherapistStackParamList } from '@/navigations/TherapistStack';
import { useLayoutEffect } from 'react';

export default function TextSet(
  props: StackScreenProps<TherapistStackParamList, 'TextSet'>,
) {
  const { setId, selectedID, apiName } = props.route?.params ?? {};

  useLayoutEffect(() => {
    if (!props.route.params.setId) {
      props.navigation.setOptions({
        title: 'Texteset erstellen',
        headerTitleAllowFontScaling: false,
      });
    }
  }, [props.navigation]);

  return (
    <TextsetContextProvider
      setId={setId}
      patientId={selectedID}
      apiName={apiName}
    >
      <SetsSelectedWrapper props={props} />
    </TextsetContextProvider>
  );
}
